
import React from "react";
import { useLocation } from "react-router-dom";
import Footer from "components/Footer";
import Header from "components/Header";

const PublicLayout = ({ children }) => {
  const location = useLocation();
  const isTermsPage = location.pathname === "/terms";

  return (
    <>
      {!isTermsPage && <Header />}
      {children}
      <Footer />
    </>
  );
};

export default PublicLayout;
